import React, {
  createContext,
  useRef,
  useEffect,
  useReducer,
  useContext,
  useCallback
} from 'react';
import { FetchCallbacksContext } from '../../internal-components/FetchCallbacks';
import fetchAPI from '../../utils/fetchAPI';
import FormBuilderShareView from '../view/FormBuilderShareView';
import getJWT from '../../utils/getJWT';
import { VINCI_SUPPORT_EMAIL } from '../../utils/Constants';

export const FormBuilderShareContext = createContext({});

const FormBuilderShareReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'update':
      return { ...state, ...payload };

    default:
      return state;
  }
};

const reducerInitialState = { groups: [] };

const FormBuilderShareEngine = ({ formId, pageId, form = {} }) => {
  const isVinciSupport =
    ((getJWT() || {}).userProfile || {}).email === VINCI_SUPPORT_EMAIL;
  const [data, dispatch] = useReducer(
    FormBuilderShareReducer,
    reducerInitialState
  );

  const { openSnackbar } = useContext(FetchCallbacksContext);
  const linkRef = useRef(null);

  const tenantURL = window.location.href.split('/' + pageId)[0];

  useEffect(() => {
    fetchAPI('/users/v1/usergroup').then(({ results }) => {
      if (results && results.length) {
        dispatch({
          type: 'update',
          payload: {
            groups: results.map(g => ({
              label: g.code,
              value: g.id,
              schemaCode: g.schemaCode
            }))
          }
        });
      }
    });
  }, []);

  const onLinkCopy = useCallback(() => {
    if (!linkRef.current) {
      return;
    }
    linkRef.current.select();
    document.execCommand('copy');
    openSnackbar('success', 'form-builder.share.link.snackbar');
  }, []);

  const viewProps = {
    linkRef,
    tenantURL,
    formId,
    isPublic: form.sharingType === 'anonymous',
    onLinkCopy,
    showTasksToggle: isVinciSupport
  };

  const contextProps = { ...data };

  return (
    <FormBuilderShareContext.Provider value={contextProps}>
      <FormBuilderShareView {...viewProps} />
    </FormBuilderShareContext.Provider>
  );
};

export default FormBuilderShareEngine;
